"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isAlert = isAlert;
exports.isToast = isToast;
exports.addToast = addToast;
exports.setAlert = setAlert;
exports.getToast = getToast;
exports.getAlert = getAlert;
exports.setSuccess = setSuccess;
exports.setInfo = setInfo;
exports.setError = setError;
exports.AlertType = exports.notificationsLine = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _omnibus = require("../utils/omnibus");

var exists = function exists(value) {
  return typeof value !== 'undefined' && value !== null;
};

var notificationsLine = (0, _omnibus.omnibus)('notifications-bucket');
exports.notificationsLine = notificationsLine;
var AlertType;
exports.AlertType = AlertType;

(function (AlertType) {
  AlertType["Error"] = "error";
  AlertType["Info"] = "info";
  AlertType["Success"] = "success";
})(AlertType || (exports.AlertType = AlertType = {}));

function isAlert(obj) {
  return typeof obj === 'undefined' || obj === null || (0, _typeof2.default)(obj) === 'object' && typeof obj.type === 'string' && (obj.type === AlertType.Error || obj.type === AlertType.Info || obj.type === AlertType.Success) && typeof obj.message === 'string';
}

var currentToast;
var currentAlert;

function isToast(obj) {
  return (0, _typeof2.default)(obj) === 'object' && typeof obj.message === 'string';
}

function addToast(toast) {
  if (toast !== null && !isToast(toast)) {
    throw new Error('Notifications.addToast: toastObject was badly formed.');
  }

  currentToast = toast ? (0, _objectSpread2.default)({}, toast) : null;
  notificationsLine.dispatch('toast', currentToast, false);
}

function setAlert(alert) {
  if (alert !== null && !isAlert(alert)) {
    throw new Error('bluemoon.components.Notifications: alert object was badly formed.');
  }

  currentAlert = alert ? (0, _objectSpread2.default)({}, alert) : null;
  notificationsLine.dispatch('alert', currentAlert, false);
}

function getToast() {
  return currentToast ? (0, _objectSpread2.default)({}, currentToast) : null;
}

function getAlert() {
  return currentAlert ? (0, _objectSpread2.default)({}, currentAlert) : null;
}

function setSuccess(message) {
  if (exists(message) && typeof message !== 'string') {
    throw new Error('Notifications.setSuccess: successMessage must be a string.');
  }

  if (message === '') {
    setAlert(null);
  } else {
    setAlert({
      type: AlertType.Success,
      message: message
    });
  }
}

function setInfo(message) {
  if (exists(message) && typeof message !== 'string') {
    throw new Error('Notifications.setInfo: successMessage must be a string.');
  }

  if (message === '') {
    setAlert(null);
  } else {
    setAlert({
      type: AlertType.Info,
      message: message
    });
  }
}

function setError(message) {
  if (exists(message) && typeof message !== 'string') {
    throw new Error('Notifications.setError: successMessage must be a string.');
  }

  if (message === '') {
    setAlert(null);
  } else {
    setAlert({
      type: AlertType.Error,
      message: message
    });
  }
}
